export default __webpack_public_path__ + "static/media/avatar.7f806e40.svg";